import { Injectable } from "@angular/core";
import { IResponse } from "../response.model";
import { TemplateApiService } from "../template-api.service";


export interface IMatrizDeImpacto{
    "0_a_50": {
        vulnerabilidade: string,
        recomendacao: string
    },
    "51_a_70": {
        vulnerabilidade: string,
        recomendacao: string
    },
    "71_a_100": {
        vulnerabilidade: string,
        recomendacao: string
    }
}

export interface IRodada extends IResponse {
    modulo: string,
    nome: string,
    descricao: string,
    posicao: number,
    matriz_de_impacto?: IMatrizDeImpacto
}

@Injectable()
export class RodadaService extends TemplateApiService<IRodada> {

    public override setBaseUrl(idTeste: any, idModulo: any){
        this.baseUrl = `admin/testes/${idTeste}/modulos/${idModulo}/rodadas`;
    }
}
